import { cn } from "@/lib/utils";
import { Progress as ShadProgress } from "@/components/ui/progress";
export function Progress({ value, className }: { value: number; className?: string }) {
  return (
    <div className={cn( className)}>
      <ShadProgress value={value} className="h-2 border border-muted-foreground"/>
      <div className="ps-1 text-xs text-foreground">{Math.round(value)} %</div>
    </div>
  )
}